import { jsx as _jsx } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { SummarySection } from '@zurich/ui/legacy/components';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
export function PolicyDetailBonusMalusSummary() {
    const { t } = useTranslation();
    const offer = useRecoilValue(offerDetailsAtom);
    const bonusMalusData = [
        {
            label: t('policy.bmStep'),
            value: offer.questionnaire?.genericQuestions?.find((question) => question.questionType === 'genericQuestion' &&
                question.question === 'bms')?.answer,
        },
        // TODO: add entry for B-M-Stufenart
        {
            label: t('policy.bmObservationPeriod'),
            value: offer.questionnaire?.genericQuestions?.find((question) => question.questionType === 'genericQuestion' &&
                question.question === 'observationPeriod')?.answer,
        },
    ];
    return (_jsx(SummarySection, { rows: bonusMalusData, title: t('policy.bonusMalus'), editable: false }));
}
